import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  trend,
  significance,
  description 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-warning';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="card hover:shadow-lg transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-primary/10">
            <Icon name={icon} size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="text-sm font-medium text-muted-foreground caption">{title}</h3>
            {description && (
              <p className="text-xs text-muted-foreground mt-1">{description}</p>
            )}
          </div>
        </div>
        {significance && (
          <span className="px-2 py-1 rounded text-xs font-medium bg-success/10 text-success">
            {significance}
          </span>
        )}
      </div>
      <div className="flex items-end justify-between">
        <div>
          <div className="text-3xl md:text-4xl font-bold text-foreground font-data mb-2">
            {value}
          </div>
          <div className={`flex items-center gap-2 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={16} />
            <span className="text-sm font-semibold font-data">{change}</span>
            <span className="text-xs text-muted-foreground">vs last period</span>
          </div>
        </div>
        {trend && (
          <div className="w-24 h-12">
            <svg viewBox="0 0 100 50" className="w-full h-full">
              <polyline
                points={trend?.map((val, idx) => `${(idx / (trend?.length - 1)) * 100},${50 - val}`)?.join(' ')}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className={getChangeColor()}
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;